import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

// Tab names accepted in the URL, e.g. /configuration/calendar-configuration?tab=working-hours.
// Order matches the mat-tab order in the template.
const CALENDAR_CONFIG_TABS = ['display', 'working-hours', 'session-start-times', 'colors'] as const;

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit, OnDestroy {

  selectedTabIndex = 0;

  private queryParamsSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.queryParamsSub = this.route.queryParamMap.subscribe(params => {
      const index = CALENDAR_CONFIG_TABS.indexOf(params.get('tab') as typeof CALENDAR_CONFIG_TABS[number]);
      this.selectedTabIndex = index >= 0 ? index : 0;
    });
  }

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe();
  }

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: index > 0 ? CALENDAR_CONFIG_TABS[index] : null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

}
